import { motion } from 'framer-motion';
import { microInteractions } from '../../utils/animations';

/**
 * Modern Card Component with Glassmorphism
 * Supports variants, hover effects, and interactive states
 */
export function Card({ 
  children, 
  variant = 'elevated',
  interactive = false,
  className = '',
  onClick,
  ...props 
}) {
  const variantClasses = {
    elevated: 'bg-white dark:bg-elevated-dark-2 shadow-soft border border-gray-200 dark:border-white/5',
    glass: 'glass glass-border shadow-soft',
    flat: 'bg-white dark:bg-elevated-dark-1',
  };

  const Component = interactive ? motion.div : 'div';
  const animationProps = interactive ? microInteractions.cardHover : {};

  return (
    <Component
      className={`squircle p-6 ${variantClasses[variant]} ${className}`}
      onClick={onClick}
      {...(interactive && animationProps)}
      {...props}
    >
      {children}
    </Component>
  );
}

export function CardHeader({ children, className = '' }) {
  return (
    <div className={`mb-4 ${className}`}>
      {children}
    </div>
  );
}

export function CardContent({ children, className = '' }) {
  return (
    <div className={`${className}`}>
      {children}
    </div>
  );
}

export function CardFooter({ children, className = '' }) {
  return (
    <div className={`mt-4 ${className}`}>
      {children}
    </div>
  );
}

export default Card;
